<template>
    <BaseModal v-model:visible="visible" :header="header">
        <img :src="imageUrl" alt="Image" class="object-contain w-full h-full">
    </BaseModal>
</template>

<script setup lang="ts">
import BaseModal from './BaseModal.vue';
const visible = defineModel('visible', {
    type: Boolean,
    default: false
});

const props = defineProps<{
    imageUrl: string;
    header?: string;
}>();

</script>

<style scoped>

</style>
